var map = {
	"./Group 22302.png": 1357,
	"./avatar-christmas.webp": 1358,
	"./bottom-bg-christmas.webp": 1359,
	"./btn-active.png": 1360,
	"./content-deco-1.webp": 1361,
	"./content-deco-2.webp": 1362,
	"./content-deco-3.webp": 1363,
	"./content-deco-4.webp": 1364,
	"./deco-3.webp": 1365,
	"./deposit-icon.webp": 1366,
	"./home-icon-active.webp": 1367,
	"./home-icon.webp": 1368,
	"./live-icon-active.webp": 1369,
	"./live-icon.webp": 1370,
	"./master-bg.jpg": 1371,
	"./master-bg.webp": 1372,
	"./me-icon-active.webp": 1373,
	"./me-icon.webp": 1374,
	"./platform.png": 1375,
	"./platform.webp": 1376,
	"./promos-icon-active.webp": 1377,
	"./promos-icon.webp": 1378,
	"./promos.webp": 1379,
	"./service-christmas.webp": 1380,
	"./snowman.webp": 1381,
	"./sponsor-icon-active.webp": 1382,
	"./sponsor-icon.webp": 1383,
	"./title-deco-left.webp": 1384,
	"./title-deco-right.webp": 1385,
	"./tree.webp": 1386,
	"./vip-icon.webp": 1387,
	"./vip.webp": 1388,
	"./withdraw-icon.webp": 1389,
	"./wwr-img.webp": 1390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;